import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { PnmacMediaQuery, PnmacMeta, PnmacOfferBlogPostCard, PnmacText, PnmacOffersAccordion, PnmacOfferTiles } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { View, Image, ScrollView, Dimensions, TouchableOpacity, ImageBackground } from 'react-native';
import { textStyle } from '../v2/theme';
import withPnmacTitle from '../withPnmacTitle';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../redux/events/events";
var Offers = /** @class */function (_super) {
  __extends(Offers, _super);
  function Offers(props) {
    var _this = this;
    var _a, _b, _c;
    _this = _super.call(this, props) || this;
    _this.getExpandedOfferId = function () {
      var expandedOffer = _this.state.offers.find(function (offer) {
        return offer.expanded;
      });
      return expandedOffer.id;
    };
    _this.handleExpandCollapseSection = function (item) {
      if (item) {
        _this.setState({
          offers: _this.state.offers.map(function (el) {
            return el.id === item.id ? Object.assign({}, el, {
              expanded: true
            }) : Object.assign({}, el, {
              expanded: false
            });
          })
        }, function () {
          var _a;
          if (!item.expanded === true) {
            _this.setState({
              selectedOfferTiles: item.tiles
            });
          }
          var trackerLabels = ["Offers/Buy A New Home|Desktop", "Offers/Refinance a Loan|Desktop", "Offers/Take Cash Out|Desktop"];
          var expandedOfferId = (_a = _this.getExpandedOfferId()) !== null && _a !== void 0 ? _a : 0;
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, trackerLabels[expandedOfferId - 1], 0);
        });
      }
    };
    _this.handleTileClick = function (tile) {
      var _a;
      if (tile) {
        var tracker2DLabels = [["New Home/Apply Now|Desktop", "New Home/Shopping|Desktop", "New Home/Rates|Desktop", "New Home/Know the Numbers |Desktop", "New Home/Top Agent|Desktop", "New Home/Loan Officer|Desktop"], ["Refinance/Apply Now |Desktop", "Refinance/Learn How it Works|Desktop", "Refinance/Rates|Desktop", "Refinance/Know the Numbers |Desktop", "Refinance/See Your Homes Worth |Desktop", "Refinance/Loan Officer |Desktop"], ["Cash/Apply Now |Desktop", "Cash/Options|Desktop", "Cash/Rates|Desktop", "Cash/Know the Numbers |Desktop", "Cash/See Your Homes Worth |Desktop", "Cash/Loan Officer|Desktop"]];
        var expandedOfferId = (_a = _this.getExpandedOfferId()) !== null && _a !== void 0 ? _a : 0;
        var tileId = tile.id;
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, tracker2DLabels[expandedOfferId - 1][tileId - 1], 0);
        window.open(tile.link, "_blank");
      }
    };
    _this.getAdsData = function () {
      var advertisement_id = 737779;
      var abkw = "42";
      var additional_query_params = '';
      var url = 'https://servedbyadbutler.com/adserve/;ID=178432;type=json;' + 'setID=' + advertisement_id + ';' + 'kw=' + abkw + ';' + 'customParam1=' + abkw + ';' + 'extra=' + abkw + ';' + additional_query_params + 'click=CLICK_MACRO_PLACEHOLDER';
      fetch(url).then(function (response) {
        return response.json();
      }).then(function (data) {
        var _a, _b, _c;
        var sanitizedString = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.placements) === null || _a === void 0 ? void 0 : _a.placement_1) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.replace(/\\r\\n|\\/g, '');
        sanitizedString = sanitizedString.substring(1);
        sanitizedString = sanitizedString.substring(0, sanitizedString.length - 1);
        sanitizedString = sanitizedString.trim();
        sanitizedString = '{ "posts": ' + sanitizedString + " }";
        var adsList = JSON.parse(sanitizedString);
        if (adsList) {
          _this.setState({
            adsData: adsList.posts
          });
        }
      }).catch(function (err) {
        return console.error(err);
      });
    };
    _this.getHomeOwnershipData = function () {
      fetch("https://qa.pennymac.com/assets/json/latest-blog-posts.json", {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "https://localhost:44380"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        _this.setState({
          homeOwnershipData: data
        });
      }).catch(function (err) {
        return console.error(err);
      });
    };
    _this.isInResponsiveMode = function () {
      var windowW = Dimensions.get("window").width;
      return windowW <= 900;
    };
    _this.buildTilesList = function () {
      return _this.state.selectedOfferTiles && _this.state.selectedOfferTiles.map(function (tile, index) {
        return /*#__PURE__*/React.createElement(PnmacOfferTiles, {
          key: index,
          item: tile,
          index: index,
          title: _this.props.translations[tile.title],
          description: _this.props.translations[tile.description],
          customWidth: _this.isInResponsiveMode() ? 135 : 140,
          customMarginRight: _this.isInResponsiveMode() ? 25 : 15,
          onPress: function () {
            _this.handleTileClick(tile);
          }
        });
      });
    };
    _this.renderOfferTiles = function (horizontal) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: "row",
          flexWrap: "wrap"
        }
      }, _this.buildTilesList());
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.DEFAULT_BLOG_POST_CARD_SIZE = 371;
    _this.DEFAULT_BLOG_POST_CARD_OFFSET = 34;
    _this.state = {
      offers: [{
        id: 1,
        title: "Buyanewhome",
        icon: require("../assets/product-icons/Icon-Buy-New-Home.png"),
        description: "buyanewtile",
        expanded: true,
        tiles: [{
          id: 1,
          title: "applynow",
          description: "applynowsubtitle",
          icon: require("../assets/product-icons/Icon-Apply-Now.png"),
          link: "".concat(props.layout.pennyHomeUrl, "api/main/redirect?goingto=BlendUrl&ids_token=").concat(props.layout.token, "&&user=").concat((_a = props.layout.userProfile) === null || _a === void 0 ? void 0 : _a.user_id)
        }, {
          id: 2,
          title: "startshopping",
          description: "startshoppingsubtitle",
          icon: require("../assets/product-icons/Icon-Start-Shopping.png"),
          link: "https://www.pennymac.com/purchase"
        }, {
          id: 3,
          title: "viewtodaysrates",
          description: "viewtodaysratessubtitle",
          icon: require("../assets/product-icons/Icon-Mortgage-Rates.png"),
          link: "https://www.pennymac.com/rates"
        }, {
          id: 4,
          title: "knowthenumbers",
          description: "knowthenumberssubtitle",
          icon: require("../assets/product-icons/Icon-Calculators.png"),
          link: "https://www.pennymac.com/mortgage-calculators"
        }, {
          id: 5,
          title: "swta",
          description: "swtasubtitle",
          icon: require("../assets/product-icons/Icon-Home-Connect.png"),
          link: "https://pennymac.homestory.co"
        }, {
          id: 6,
          title: "loanofficer",
          description: "loanofficersubtitle",
          icon: require("../assets/product-icons/Icon-Loan-Officer.png"),
          link: "https://www.pennymac.com/find-loan-officer"
        }]
      }, {
        id: 2,
        title: "RefinanceaLoan",
        icon: require("../assets/product-icons/Icon-Refinance-Home.png"),
        description: "Refinancetilecard",
        expanded: false,
        tiles: [{
          id: 1,
          title: "applynow",
          description: "applynowsubtitle",
          icon: require("../assets/product-icons/Icon-Apply-Now.png"),
          link: "".concat(props.layout.pennyHomeUrl, "api/main/redirect?goingto=BlendUrl&ids_token=").concat(props.layout.token, "&&user=").concat((_b = props.layout.userProfile) === null || _b === void 0 ? void 0 : _b.user_id)
        }, {
          id: 2,
          title: "LearnHowItWorks",
          description: "LearnHowItWorkssubtitle",
          icon: require("../assets/product-icons/Icon-Start-Shopping.png"),
          link: "https://www.pennymac.com/refinancing/how-refinancing-works"
        }, {
          id: 3,
          title: "viewtodaysrates",
          description: "viewtodaysratessubtitle",
          icon: require("../assets/product-icons/Icon-Mortgage-Rates.png"),
          link: "https://www.pennymac.com/rates"
        }, {
          id: 4,
          title: "knowthenumbers",
          description: "knowthenumberssubtitle",
          icon: require("../assets/product-icons/Icon-Calculators.png"),
          link: "https://www.pennymac.com/mortgage-calculators"
        }, {
          id: 5,
          title: "seeyourhomeworth",
          description: "seeyourhomeworthsubtitle",
          icon: require("../assets/product-icons/Icon-Home-Connect.png"),
          link: "https://www.pennymac.com/home-value-estimator"
        }, {
          id: 6,
          title: "loanofficer",
          description: "loanofficersubtitle",
          icon: require("../assets/product-icons/Icon-Loan-Officer.png"),
          link: "https://www.pennymac.com/find-loan-officer"
        }]
      }, {
        id: 3,
        title: "cashout",
        icon: require("../assets/product-icons/Icon-Take-Cash-Out.png"),
        description: "takecashtile",
        expanded: false,
        tiles: [{
          id: 1,
          title: "applynow",
          description: "applynowsubtitle",
          icon: require("../assets/product-icons/Icon-Apply-Now.png"),
          link: "".concat(props.layout.pennyHomeUrl, "api/main/redirect?goingto=BlendUrl&ids_token=").concat(props.layout.token, "&&user=").concat((_c = props.layout.userProfile) === null || _c === void 0 ? void 0 : _c.user_id)
        }, {
          id: 2,
          title: "compareoptions",
          description: "compareoptionssubtitle",
          icon: require("../assets/product-icons/Icon-Start-Shopping.png"),
          link: "https://www.pennymac.com/mortgage-rates/home-equity-loans"
        }, {
          id: 3,
          title: "viewtodaysrates",
          description: "viewtodaysratessubtitle",
          icon: require("../assets/product-icons/Icon-Mortgage-Rates.png"),
          link: "https://www.pennymac.com/rates"
        }, {
          id: 4,
          title: "knowthenumbers",
          description: "knowthenumberssubtitle",
          icon: require("../assets/product-icons/Icon-Calculators.png"),
          link: "https://www.pennymac.com/mortgage-calculators"
        }, {
          id: 5,
          title: "seeyourhomeworth",
          description: "seeyourhomeworthsubtitle",
          icon: require("../assets/product-icons/Icon-Home-Connect.png"),
          link: "https://www.pennymac.com/home-value-estimator"
        }, {
          id: 6,
          title: "loanofficer",
          description: "loanofficersubtitle",
          icon: require("../assets/product-icons/Icon-Loan-Officer.png"),
          link: "https://www.pennymac.com/find-loan-officer"
        }]
      }],
      selectedOfferTiles: undefined,
      adsData: [],
      currentAdsDivWidth: 0,
      adsNavigation: {
        maxClicks: 0,
        currentPadding: 0,
        leftArrowClicks: 0,
        rightArrowClicks: 0
      },
      homeOwnershipNavigation: {
        maxClicks: 0,
        currentPadding: 0,
        leftArrowClicks: 0,
        rightArrowClicks: 0
      },
      homeOwnershipData: [{
        post_date: "August 15, 2024",
        post_title: "Mortgage Interest Deduction: Here’s What Qualifies",
        post_breadcrumb_title: "Mortgage Interest Deduction",
        post_summary: "Owning a home comes with certain tax benefits, including an opportunity to deduct mortgage interest. Here’s an overview of what qualifies for a deduction and what doesn’t.",
        post_url: "https://www.pennymac.com/blog/mortgage-interest-deduction",
        post_image_url: "https://www.pennymac.com/assets/images/posts-tablet/mortgage-interest-deduction.jpg"
      }, {
        post_date: "August 14, 2024",
        post_title: "Why Servicing With Pennymac Makes a Difference",
        post_breadcrumb_title: "Pennymac's Mortgage Servicing",
        post_summary: "Our customer-first service is guided by our core values of being Accountable, Reliable and Ethical.",
        post_url: "https://www.pennymac.com/blog/why-servicing-with-pennymac-makes-a-difference",
        post_image_url: "https://www.pennymac.com/assets/images/posts-tablet/why-servicing-with-pennymac-makes-a-difference.jpg"
      }, {
        post_date: "August 14, 2024",
        post_title: "Tips for Buying and Selling a Home at the Same Time",
        post_breadcrumb_title: "Buying and Selling a Home Simultaneously",
        post_summary: "Balancing the sale of your current home with the purchase of a new one requires careful planning. Here are tips to help you navigate this transition seamlessly.",
        post_url: "https://www.pennymac.com/blog/tips-for-buying-and-selling-a-home-at-the-same-time",
        post_image_url: "https://www.pennymac.com/assets/images/posts-tablet/tips-for-buying-and-selling-a-home-at-the-same-time.jpg"
      }, {
        post_date: "August 13, 2024",
        post_title: "What Is Streamline Refinancing?",
        post_breadcrumb_title: "Streamline Refinancing",
        post_summary: "Looking to lower monthly payments or move out of an adjustable-rate mortgage? Learn about streamline refinancing and how it makes loan approval easier.",
        post_url: "https://www.pennymac.com/blog/what-is-streamline-refinancing",
        post_image_url: "https://www.pennymac.com/assets/images/posts-tablet/what-is-streamline-refinancing.jpg"
      }, {
        post_date: "September  2, 2024",
        post_title: "Understanding Loan Processors and Mortgage Processing",
        post_breadcrumb_title: "Mortgage Processing",
        post_summary: "Your Loan Processor plays a key role in securing your new home. Explore what they do and tips for facilitating a smooth mortgage experience.",
        post_url: "https://www.pennymac.com/blog/explaining-the-loan-process-part-3-processing",
        post_image_url: "https://www.pennymac.com/assets/images/posts-tablet/explaining-the-loan-process-part-3-processing.jpg"
      }, {
        post_date: "September  1, 2024",
        post_title: "Explaining the Loan Process Part 4: Mortgage Underwriting",
        post_breadcrumb_title: "Underwriting",
        post_summary: "During the underwriting stage, a lender evaluates your financial qualifications to determine your creditworthiness and loan risk. Here’s how it works and what to expect.",
        post_url: "https://www.pennymac.com/blog/explaining-the-loan-process-part-4-mortgage-underwriting",
        post_image_url: "https://www.pennymac.com/assets/images/posts-tablet/explaining-the-loan-process-part-4-mortgage-underwriting.jpg"
      }]
    };
    return _this;
  }
  ;
  Offers.prototype.componentDidMount = function () {
    this.setState({
      selectedOfferTiles: this.state.offers[0].tiles
    });
    this.getAdsData();
    this.getHomeOwnershipData();
  };
  ;
  Offers.prototype.render = function () {
    var _this = this;
    var translations = this.props.translations;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1350px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          paddingHorizontal: _this.isInResponsiveMode() ? 10 : 20,
          paddingBottom: 10,
          marginTop: -10,
          marginRight: _this.isInResponsiveMode() ? 15 : null
        },
        id: "main-content"
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.ProductsAndOffers
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: "white",
          borderRadius: 10,
          padding: 20
        },
        onLayout: function (event) {
          var _a, _b;
          var _c = event.nativeEvent.layout,
            x = _c.x,
            y = _c.y,
            width = _c.width,
            height = _c.height;
          var allCardsSizeHomeownership = _this.state.homeOwnershipData.length * _this.DEFAULT_BLOG_POST_CARD_SIZE + _this.DEFAULT_BLOG_POST_CARD_OFFSET * ((_a = _this.state.homeOwnershipData) === null || _a === void 0 ? void 0 : _a.length);
          var allCardsSizeAds = _this.state.adsData.length * _this.DEFAULT_BLOG_POST_CARD_SIZE + _this.DEFAULT_BLOG_POST_CARD_OFFSET * ((_b = _this.state.adsData) === null || _b === void 0 ? void 0 : _b.length);
          _this.setState({
            currentAdsDivWidth: width,
            homeOwnershipNavigation: {
              maxClicks: Math.abs(Math.round((allCardsSizeHomeownership - width - 71) / _this.DEFAULT_BLOG_POST_CARD_SIZE) + 1),
              currentPadding: _this.state.homeOwnershipNavigation.currentPadding,
              leftArrowClicks: _this.state.homeOwnershipNavigation.leftArrowClicks,
              rightArrowClicks: _this.state.homeOwnershipNavigation.rightArrowClicks
            },
            adsNavigation: {
              maxClicks: Math.abs(Math.round((allCardsSizeAds - width - 71) / _this.DEFAULT_BLOG_POST_CARD_SIZE) + 1),
              currentPadding: _this.state.adsNavigation.currentPadding,
              leftArrowClicks: _this.state.adsNavigation.leftArrowClicks,
              rightArrowClicks: _this.state.adsNavigation.rightArrowClicks
            }
          });
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.formTitleSection, {
          fontSize: 22,
          fontFamily: "Montserrat",
          fontWeight: "600"
        }]
      }, "Home Loans"), /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.nonActiveTabText, {
          textAlign: "left",
          fontSize: 13,
          fontFamily: "HalenoirCompactText-Regular"
        }]
      }, translations.Homeloans))), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: _this.isInResponsiveMode() ? 'column' : "row",
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1,
          flexGrow: 1
        }
      }, _this.state.offers.map(function (item, index) {
        return /*#__PURE__*/React.createElement(PnmacOffersAccordion, {
          key: index,
          item: item,
          title: translations[item.title],
          description: translations[item.description],
          isLastItem: index === _this.state.offers.length - 1,
          childrenContent: _this.isInResponsiveMode() ? _this.renderOfferTiles(false) : null,
          onPress: function () {
            _this.handleExpandCollapseSection(item);
          }
        });
      })), !_this.isInResponsiveMode() && (/*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          flexGrow: 4,
          flexDirection: "row",
          flexWrap: "wrap",
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          paddingVertical: 10,
          paddingHorizontal: 10,
          width: _this.isInResponsiveMode() ? "100%" : '98%'
        }
      }, _this.renderOfferTiles(!_this.isInResponsiveMode())))))), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 3,
          flexGrow: 3,
          marginTop: 15,
          maxWidth: _this.state.currentAdsDivWidth * 99 / 100
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.formTitleSection, {
          fontSize: 22,
          marginTop: 15,
          fontFamily: "Montserrat",
          fontWeight: "600"
        }]
      }, "Featured products & tools"), _this.state.adsNavigation.rightArrowClicks > 0 && (/*#__PURE__*/React.createElement(View, {
        style: {
          position: "absolute",
          left: 5,
          height: "100%",
          zIndex: 10000,
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          if (_this.state.adsNavigation.rightArrowClicks > 0) {
            _this.setState({
              adsNavigation: __assign(__assign({}, _this.state.adsNavigation), {
                currentPadding: _this.state.adsNavigation.currentPadding - (_this.DEFAULT_BLOG_POST_CARD_SIZE + _this.DEFAULT_BLOG_POST_CARD_OFFSET),
                leftArrowClicks: _this.state.adsNavigation.leftArrowClicks + 1,
                rightArrowClicks: _this.state.adsNavigation.rightArrowClicks - 1
              })
            });
          }
        }
      }, /*#__PURE__*/React.createElement(Image, {
        resizeMode: "contain",
        source: require("../assets/carouselScrollLeft.png"),
        style: {
          width: 75,
          height: 75,
          opacity: 0.8
        }
      })))), /*#__PURE__*/React.createElement(ScrollView, {
        style: {
          flexDirection: "row"
        },
        horizontal: true,
        scrollEnabled: false,
        showsHorizontalScrollIndicator: false
      }, (_a = _this.state.adsData) === null || _a === void 0 ? void 0 : _a.map(function (slide, index) {
        return /*#__PURE__*/React.createElement(View, {
          key: index,
          style: {
            marginRight: 34,
            marginTop: 10,
            left: _this.state.adsNavigation.currentPadding > 0 ? _this.state.adsNavigation.currentPadding * -1 : null
          }
        }, /*#__PURE__*/React.createElement(PnmacOfferBlogPostCard, {
          onPress: function () {
            if (slide.post_url) {
              window.open(slide.post_url, "_blank");
              var label = "Offers/Carousel |Desktop";
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, 0);
            }
          },
          customTitleTextColor: "#333333",
          key: index,
          item: slide
        }));
      })), _this.state.adsNavigation.rightArrowClicks < _this.state.adsNavigation.maxClicks - 1 && _this.state.adsNavigation.maxClicks > 0 && (/*#__PURE__*/React.createElement(View, {
        style: {
          position: "absolute",
          right: 5,
          height: "100%",
          zIndex: 10000,
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          if (_this.state.adsNavigation.rightArrowClicks < _this.state.adsNavigation.maxClicks - 1) {
            _this.setState({
              adsNavigation: {
                maxClicks: _this.state.adsNavigation.maxClicks,
                currentPadding: _this.state.adsNavigation.currentPadding,
                leftArrowClicks: _this.state.adsNavigation.leftArrowClicks - 1,
                rightArrowClicks: _this.state.adsNavigation.rightArrowClicks + 1
              }
            }, function () {
              _this.setState({
                adsNavigation: {
                  maxClicks: _this.state.adsNavigation.maxClicks,
                  currentPadding: _this.DEFAULT_BLOG_POST_CARD_SIZE * _this.state.adsNavigation.rightArrowClicks + _this.DEFAULT_BLOG_POST_CARD_OFFSET * _this.state.adsNavigation.rightArrowClicks,
                  leftArrowClicks: _this.state.adsNavigation.leftArrowClicks,
                  rightArrowClicks: _this.state.adsNavigation.rightArrowClicks
                }
              });
            });
          }
        }
      }, /*#__PURE__*/React.createElement(Image, {
        resizeMode: "contain",
        source: require("../assets/carouselScrollRight.png"),
        style: {
          width: 75,
          height: 75,
          opacity: 0.8
        }
      }))))), /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 10,
          marginLeft: -34,
          maxWidth: _this.state.currentAdsDivWidth * 99 / 100 + 68
        }
      }, /*#__PURE__*/React.createElement(ImageBackground, {
        source: require("../assets/homeOwnershipPostsBG.png"),
        resizeMode: "cover",
        style: {
          width: '100%',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 34,
          marginBottom: 15,
          maxWidth: _this.state.currentAdsDivWidth * 99 / 100
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.formTitleSection, {
          fontSize: 22,
          marginTop: 15,
          fontFamily: "Montserrat",
          fontWeight: "600"
        }]
      }, "Homeownership"), _this.state.homeOwnershipNavigation.rightArrowClicks > 0 && (/*#__PURE__*/React.createElement(View, {
        style: {
          position: "absolute",
          left: 5,
          height: "100%",
          zIndex: 10000,
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          if (_this.state.homeOwnershipNavigation.rightArrowClicks > 0) {
            _this.setState({
              homeOwnershipNavigation: __assign(__assign({}, _this.state.homeOwnershipNavigation), {
                currentPadding: _this.state.homeOwnershipNavigation.currentPadding - (_this.DEFAULT_BLOG_POST_CARD_SIZE + _this.DEFAULT_BLOG_POST_CARD_OFFSET),
                leftArrowClicks: _this.state.homeOwnershipNavigation.leftArrowClicks + 1,
                rightArrowClicks: _this.state.homeOwnershipNavigation.rightArrowClicks - 1
              })
            });
          }
        }
      }, /*#__PURE__*/React.createElement(Image, {
        resizeMode: "contain",
        source: require("../assets/carouselScrollLeft.png"),
        style: {
          width: 75,
          height: 75,
          opacity: 0.8
        }
      })))), /*#__PURE__*/React.createElement(ScrollView, {
        style: {
          flexDirection: "row"
        },
        horizontal: true,
        scrollEnabled: false,
        showsHorizontalScrollIndicator: false
      }, (_b = _this.state.homeOwnershipData) === null || _b === void 0 ? void 0 : _b.map(function (slide, index) {
        return /*#__PURE__*/React.createElement(View, {
          key: index,
          style: {
            marginRight: 34,
            marginTop: 10,
            left: _this.state.homeOwnershipNavigation.currentPadding > 0 ? _this.state.homeOwnershipNavigation.currentPadding * -1 : null
          }
        }, /*#__PURE__*/React.createElement(PnmacOfferBlogPostCard, {
          onPress: function () {
            if (slide.post_url) {
              window.open(slide.post_url, "_blank");
              var label = "Offers/Homeownership|Desktop";
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, 0);
            }
          },
          customTitleTextColor: "#333333",
          key: index,
          item: slide
        }));
      })), _this.state.homeOwnershipNavigation.rightArrowClicks < _this.state.homeOwnershipNavigation.maxClicks - 1 && _this.state.homeOwnershipNavigation.maxClicks > 0 && (/*#__PURE__*/React.createElement(View, {
        style: {
          position: "absolute",
          right: 5,
          height: "100%",
          zIndex: 10000,
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          if (_this.state.homeOwnershipNavigation.rightArrowClicks < _this.state.homeOwnershipNavigation.maxClicks - 1) {
            _this.setState({
              homeOwnershipNavigation: {
                maxClicks: _this.state.homeOwnershipNavigation.maxClicks,
                currentPadding: _this.state.homeOwnershipNavigation.currentPadding,
                leftArrowClicks: _this.state.homeOwnershipNavigation.leftArrowClicks - 1,
                rightArrowClicks: _this.state.homeOwnershipNavigation.rightArrowClicks + 1
              }
            }, function () {
              _this.setState({
                homeOwnershipNavigation: {
                  maxClicks: _this.state.homeOwnershipNavigation.maxClicks,
                  currentPadding: _this.DEFAULT_BLOG_POST_CARD_SIZE * _this.state.homeOwnershipNavigation.rightArrowClicks + _this.DEFAULT_BLOG_POST_CARD_OFFSET * _this.state.homeOwnershipNavigation.rightArrowClicks,
                  leftArrowClicks: _this.state.homeOwnershipNavigation.leftArrowClicks,
                  rightArrowClicks: _this.state.homeOwnershipNavigation.rightArrowClicks
                }
              });
            });
          }
        }
      }, /*#__PURE__*/React.createElement(Image, {
        resizeMode: "contain",
        source: require("../assets/carouselScrollRight.png"),
        style: {
          width: 75,
          height: 75,
          opacity: 0.8
        }
      })))))))));
    });
  };
  return Offers;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(Offers, function (props) {
  return props.translations.ProductsAndOffers;
}));